// extracted by mini-css-extract-plugin
export default {"root":"AnchorScrollItem_root__gbhqr"};